import React, { useState, useMemo } from 'react'
import {
  Box,
  Text,
  useResponsiveWrapperContext,
} from '@usap/uicomponents'
import { QtyDropDown } from '@usap/widgets'
import useSetQuantity from './hooks/useSetQuantity'
import useWmoEnabled from '../../../../../../hooks/useWmoEnabled'
import QuantityWmo from './QuantityWmo'
import constants from '../../../../constants'

const Quantity = props => {
  const { data, index } = props
  const [dropDown, setDropDown] = useState(false)
  const { isDesktop } = useResponsiveWrapperContext()

  const setQuantity = useSetQuantity({
    data,
  })

  const style = useMemo(
    () => ({
      wrapperDirection: isDesktop === true ? 'column' : 'row',
      wrapperGap: isDesktop === true ? '' : 'small',
      labelTextSize: isDesktop === true ? 'xsmall' : 'small',
      labelTextWeight: isDesktop === true ? 'bold' : '',
      dropDownContainerMargin: {
        top: isDesktop === true ? 'medium' : '',
      },
      textContainerMargin: {
        top: isDesktop === true ? 'medium' : '',
      },
    }),
    [isDesktop],
  )

  const isWmoEnabled = useWmoEnabled()

  if (isWmoEnabled) {
    return (
      <QuantityWmo
        data={data}
        index={index}
        setQuantity={setQuantity}
      />
    )
  }

  return (
    <Box
      direction={style.wrapperDirection}
      gap={style.wrapperGap}
      align="left"
      justify="center"
    >
      <Box justify="center">
        <Text
          size={style.labelTextSize}
          weight={style.labelTextWeight}
          color="dark-1"
        >
          QTY
        </Text>
      </Box>
      <Box
        margin={style.dropDownContainerMargin}
        justify="center"
      >
        <QtyDropDown
          dropDown={dropDown}
          setDropDown={setDropDown}
          selectedValue={data.modifiers.quantity}
          setSelectedValue={setQuantity}
          options={data.inventory.quantity <= constants.MAX_QUANTITY ? data.inventory.quantity : constants.MAX_QUANTITY}
          wrapperWidth="70px"
          wrapperHeight="34px"
          absoluteTop="32px"
          index={index}
          disabled={data.inventory.quantity < 1}
        />
      </Box>

      <Box
        margin={style.textContainerMargin}
        justify="center"
      >
        {data.inventory.quantity > 0 && (
          <Text
            size="small"
            color="blueLink"
            textAlign="center"
          >
            {data.inventory.quantity > 5 ? 'In Stock' : `${data.inventory.quantity} Unit${data.inventory.quantity > 1 ? 's' : ''} Left`}
          </Text>
        )}

        {data.inventory.quantity === 0 && (
          <Text
            size="small"
            color="red"
            textAlign="center"
          >
            Out of Stock
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default Quantity
